/**
 * Factory for creating authentication strategies
 */

import { IAuthStrategy } from './IAuthStrategy';
import {
  NativeAuthStrategy,
  INativeAuthStrategyParams
} from './NativeAuthStrategy';
import { WebAuthStrategy, IWebAuthStrategyParams } from './WebAuthStrategy';

/**
 * Parameters for creating authentication strategies
 */
export interface IAuthStrategyFactoryParams
  extends INativeAuthStrategyParams,
    IWebAuthStrategyParams {
  isNative: boolean;
}

/**
 * It follows Factory Pattern to encapsulate strategy creation logic
 */
export class AuthStrategyFactory {
  /**
   * Creates the appropriate authentication strategy based on the platform
   */
  static createStrategy(params: IAuthStrategyFactoryParams): IAuthStrategy {
    const { isNative, ...strategyParams } = params;

    if (isNative) {
      return new NativeAuthStrategy({
        authRefreshContainer: strategyParams.authRefreshContainer,
        eventService: strategyParams.eventService,
        navigationService: strategyParams.navigationService,
        initialNavigationStateRepository:
          strategyParams.initialNavigationStateRepository,
        tenantHandlerService: strategyParams.tenantHandlerService,
        sessionService: strategyParams.sessionService,
        userOnboardingService: strategyParams.userOnboardingService,
        refreshScreenOnChange: strategyParams.refreshScreenOnChange,
        nativeRefreshServicesOnAuthChange:
          strategyParams.nativeRefreshServicesOnAuthChange
      });
    } else {
      return new WebAuthStrategy({
        authRefreshContainer: strategyParams.authRefreshContainer,
        webUIRefreshOnAuthChange: strategyParams.webUIRefreshOnAuthChange
      });
    }
  }
}
